const deleteConfirmationMixin = {
  data: function() {
    return {
      deleting: false,
      deleteConfirmationDialogVisible: false
    }
  },
  methods: {
    toggleConfirmationDialog(visible) {
      this.deleteConfirmationDialogVisible = visible
    }
  }
}

export default deleteConfirmationMixin
